import logoBrand from '@/assets/video/logoLoading.svg'

export function LoadingLogo (): JSX.Element {
  return (
    <div className='w-screen h-screen flex justify-center items-center bg-white flex-col gap-8'>
      <img
        src={logoBrand}
        alt='logo'
        className='w-[80px] h-80 animate-spin-horizontal'
      />
    </div>
  )
}
